// import React from "react";
// import { BadgingContent } from "../Components/BadgingContent";

// const Badging = () => {
//   return <BadgingContent />;
// };

// export default Badging;
import React from "react";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";
import { BadgingContent } from "../Components/BadgingContent";

const Badging = () => {
  const seoData = getSEOData("/badging");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <BadgingContent />
    </>
  );
};

export default Badging;